import { LINKEDIN_OAUTH_CALLBACK_PATH } from '#shared/constants/linkedIn'

/**
 * Returns the canonical LinkedIn OAuth redirect URI used for both
 * authorization and token exchange.
 */
export function useLinkedInRedirectUri() {
    const config = useRuntimeConfig()

    const getLinkedInRedirectUri = (): string => {
        const siteUrl = (config.public.siteUrl as string | undefined)?.trim()
        const isProduction = config.public.NODE_ENV === 'production'

        if (isProduction && siteUrl) {
            const canonicalOrigin = /^https?:\/\//.test(siteUrl) ? siteUrl : `https://${siteUrl}`
            return new URL(LINKEDIN_OAUTH_CALLBACK_PATH, canonicalOrigin).href
        }

        if (import.meta.client) {
            return new URL(LINKEDIN_OAUTH_CALLBACK_PATH, window.location.origin).href
        }

        return LINKEDIN_OAUTH_CALLBACK_PATH
    }

    return {
        getLinkedInRedirectUri
    }
}
